module.exports = __webpack_public_path__ + "static/img/fill-send.bcea82f7.svg";